import {useMutation, useQuery} from 'admin/lib/apollo'
import {GET_PAYMENT_DETAIL, CREATE_PAYMENT_DETAIL, UPDATE_PAYMENT_DETAIL} from 'admin/gql/PaymentDetail.gql'
import clearCache from './clearCache'

export default (organisationId, paymentDetailId) => {
  const {data: {paymentDetail = {}} = {}, error: getError} = useQuery(GET_PAYMENT_DETAIL, {
    variables: {organisationId, paymentDetailId},
    skip: !paymentDetailId
  })

  const [create, {error: createError}] = useMutation(CREATE_PAYMENT_DETAIL, {
    variables: {organisationId},
    flash: 'Payment detail created',
    update: cache => clearCache({organisation: {id: organisationId}})(cache)
  })

  const [update, {error: updateError}] = useMutation(UPDATE_PAYMENT_DETAIL, {
    variables: {organisationId, paymentDetailId},
    flash: 'Payment detail updated'
  })

  return {
    paymentDetail,
    errors: getError || createError || updateError || {},
    create,
    update
  }
}
